import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  colaboradores: [],
};

const getters = {
  // Colaborador
  colaboradores: state => state.colaboradores.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Colaborador
  async fetchColaboradores({ commit }) {
    const response = await axios.get(`${baseUrl}/colaboradores?resumido=true`);
    if (response.data.length) {
      commit('setColaboradores', response.data);
    } else {
      commit('setColaboradores', []);
    }
  },
  async fetchColaboradoresSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/colaboradores?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setColaboradores', response.data);
      } else {
        commit('setColaboradores', []);
      }
    } catch (error) {
      commit('setColaboradores', []);
    }
  },
  async addColaborador({ commit }, colaborador) {
    const response = await axios.post(`${baseUrl}/colaboradores`, colaborador, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    colaborador.IdColaborador = response.data.IdColaborador;
    commit('newColaborador', colaborador);
    return response.data.IdColaborador;
  },
  async updateColaborador({ commit }, updColaborador) {
    await axios.put(`${baseUrl}/colaboradores`, updColaborador, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateColaborador', updColaborador);
  },
  async deleteColaborador({ commit }, id) {
    await axios.delete(`${baseUrl}/colaboradores/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeColaborador', id);
  },
}

const mutations = {
  // Colaborador
  setColaboradores: (state, colaboradores) => state.colaboradores = colaboradores,
  newColaborador: (state, colaborador) => state.colaboradores.push(colaborador),
  removeColaborador: (state, id) => state.colaboradores = state.colaboradores.filter(colaborador => colaborador.IdColaborador !== id),
  updateColaborador: (state, updColaborador) => {
    const index = state.colaboradores.findIndex(colaborador => colaborador.IdColaborador === updColaborador.IdColaborador);
    if (index !== -1) {
      state.colaboradores.splice(index, 1, updColaborador);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}